import FluidPay, { FluidPayBlock } from './components/FluidPay';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  FluidPayBlock(bm, labelShoppingCartCategory, labels.fluid, types.fluid);
  FluidPay(dc, labels.fluid, types.fluid, opts);
};
